import { NewConnectionLotValues } from "../types/NewConnectionLotValues";

export const EMPTY_NEW_CONNECTION_LOT_VALUES: NewConnectionLotValues = {
  type: "Residential",
  phase: 1,
  fuseAmp: "60",
};
